import { TheNightlySection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import { SiteMapV4DTO } from '@west-australian-newspapers/publication-types'
import {
    BaseClientConfig,
    GetRouteAdTargeting,
    PageType,
} from '@news-mono/web-common'
import { layout } from '../../App.routing'

export function createSiteMapPage(
    _: BaseClientConfig,
    getAdTargeting: GetRouteAdTargeting,
    section: TheNightlySection,
    siteMap: SiteMapV4DTO,
): PageType<TheNightlySection> {
    const heading = getSiteMapPageTitle(siteMap)
    const description =
        'Explore The Nightly’s complete article archive index. Browse all published content, including breaking news, opinion, business, politics, and in-depth coverage across all topics.'

    return {
        kind: 'page',
        heading,
        pageType: 'page',
        hideHeading: true,
        refreshOnInactive: false,
        socialMeta: {
            title: heading,
            description,
        },
        pageMeta: {
            title: heading,
            description,
        },
        adTargeting: getAdTargeting('home', section, 'default'),
        section: section,

        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: '100%',
                    horizontalGutters: false,
                    verticalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                verticalSpacing: 'md',
                                containerWidth:
                                    metrics.thenightly.siteMetrics
                                        .mainContentWidth,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'site-map',
                                        props: {},
                                    }),
                                ],
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}

function getSiteMapPageTitle(siteMap: SiteMapV4DTO) {
    if (siteMap.indexType === 'year') {
        return 'Site Map'
    }

    const month = new Intl.DateTimeFormat('en-US', {
        month: 'long',
    }).format(new Date(0, siteMap.month - 1))

    if (siteMap.indexType === 'month') {
        return `Site Map for ${month} ${siteMap.year}`
    }

    if (siteMap.indexType === 'day') {
        return `Site Map for ${month} ${siteMap.currentDay}, ${siteMap.year}`
    }

    return 'Site Map'
}
